



















































































import { Component, Vue } from 'vue-property-decorator';
import UserIcon from 'mdi-vue/AccountSearch';
import AddIcon from 'mdi-vue/Plus';
import CheckIcon from 'mdi-vue/Check';
import CloseIcon from 'mdi-vue/Close';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import api from '@/libs/api';
import Modal from '@/components/Modal.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import numberFormat from '@/libs/numberFormat';
import FormInput from '@/components/FormInput.vue';
import {
  InvoiceListProfileResponse, InvoiceProduct, User,
} from '@/libs/api.interfaces';
import { mapState } from 'vuex';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

interface InvoiceProductDetail extends InvoiceProduct {
  profile_id: string;
}

@Component({
  components: {
    Modal,
    FormInput,
    LayoutTitle,
    LayoutContent,
    TagInput,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchField,
    SearchRow,
    Select,
    TableBody,
    ScrollbarWrapper,
    UserIcon,
    AddIcon,
    CheckIcon,
    CloseIcon,
  },
  data() {
    return {
      listItems: [
        {
          productName: '',
          quantity: '',
          price: '',
          total: '',
        },
      ],
    };
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class ProductEditor extends Vue {
  user!: {
    user: User;
  };

  merchantId = 0;

  loadingSubmit = false;
  loading = true;
  loadingProfile = true;

  name = '';
  price = '';
  profiles: LabelValue[] = [];
  selectedProfile: LabelValue | null = null;
  status = { label: 'Active', value: '1' };

  async submit() {
    try {
      this.loadingSubmit = true;

      /* eslint-disable @typescript-eslint/camelcase */
      const form: {
        profile: string;
        profile_id: string;
        product_name: string;
        price: string;
        status: string;
        id?: string;
      } = {
        profile: this.selectedProfile?.value || '',
        profile_id: this.selectedProfile?.value || '',
        product_name: this.name,
        price: this.price,
        status: this.status.value,
      };
      /* eslint-enable @typescript-eslint/camelcase */

      let data;
      if (this.$route.name === 'EasyInvoiceProductEdit') {
        form.id = this.$route.params.id;
        data = await api.post('/easyinvoice/products_edit', form);
      } else {
        data = await api.post('/easyinvoice/products_add', form);
      }

      if (data.data.status === '00') {
        showToast(ToastType.SUCCESS, 'Success', data.data.message);
        this.$router.push({ name: 'EasyInvoiceProducts' });
      } else {
        showToast(ToastType.FAILED, data.data.case, data.data.message.join(', '));
      }

      this.loadingSubmit = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getProduct() {
    try {
      this.loading = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceProductDetail>('/easyinvoice/products_detail', {
        user_group: 0,
        merch_id: this.merchantId,
        id: this.$route.params.id,
      });

      this.name = data.product_name;
      this.status = data.status === '1' ? { label: 'Active', value: '1' } : { label: 'Inactive', value: '0' };
      this.price = data.price;
      this.selectedProfile = this.profiles.find((e) => e.value === data.profile_id) || null;

      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getProfiles() {
    try {
      this.loadingProfile = true;
      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await api.post<InvoiceListProfileResponse>('/easyinvoice/invoices_list_profile', {
        user_group: 0,
        merch_id: this.merchantId,
      });

      this.profiles = data.profile.map((e) => ({ label: e.name, value: e.id }));
      this.loadingProfile = false;
    } catch (err) {
      console.error(err);
    }
  }

  async mounted() {
    this.merchantId = this.user.user.merchant_id;
    await this.getProfiles();
    if (this.$route.name === 'EasyInvoiceProductEdit') {
      this.getProduct();
    } else {
      this.loading = false;
    }
  }
}
